import { AxiosError, AxiosResponse } from 'axios';
import type { SetRequired } from 'type-fest';

import { Codeowners } from '../../consts/codeowners';

export type NetworkError<TData = unknown> = AxiosError<TData, unknown>;

export type InternalErrorType<TError extends string> = TError extends never
  ? never
  : {
      status: TError;
      data: null;
      error: AxiosResponse<unknown, unknown>;
    };
export const UNHANDLED_ERROR = 'unhandledError' as const;
export const SUCCESS_STATUS = 'success' as const;

export type AxiosErrorHandlerResponse<TNetworkErrors> = TNetworkErrors | typeof UNHANDLED_ERROR;

export type AxiosErrorHandler<TNetworkErrors> = (
  error: SetRequired<NetworkError, 'response'>,
  codeowners: Codeowners
) => AxiosErrorHandlerResponse<TNetworkErrors>;
